import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { AppState } from 'src';

import { CILNotificationViewModel } from '@services/CILNotificationService';

import { checkBox, checkDate, checkSignature, gotoPage, leave } from '../cil.actions';
import {
  CILNotificationCILComponent,
  CILNotificationCILComponentPage,
  CILNotificationCILComponentProperties
} from './cil.component';
import { CILNotificationCILState } from '../cil.reducer';

export interface CILNotificationCILProperties {
  readonly viewModel: CILNotificationViewModel;

  readonly submitCIL: () => void;
  readonly leave: () => void;
}

// This is used to translate the state of the page to the props on the component
function mapStateToProps(
  state: AppState,
  ownProps: CILNotificationCILProperties
): Partial<CILNotificationCILComponentProperties> {
  return {
    date: state.cilNotification.cil.date,
    isDateInvalid: state.cilNotification.cil.hasInvalidDate,
    isSubmitEnabled: state.cilNotification.cil.isSubmitEnabled,
    page: state.cilNotification.cil.page,
    viewModel: ownProps.viewModel
  };
}

// This should create proxy wrappers for actions used by the component
function mapDispatchToProps(
  dispatch: Dispatch<CILNotificationCILState>,
  ownProps: CILNotificationCILProperties
): Partial<CILNotificationCILComponentProperties> {
  return {
    checkBox: () => dispatch(checkBox()),
    checkDate: (date: Date) => dispatch(checkDate(date)),
    checkSignature: (signature: string) => dispatch(checkSignature(signature)),
    gotoPage: (page: CILNotificationCILComponentPage) => dispatch(gotoPage(page)),
    leave: () => {
      dispatch(leave());
      ownProps.leave();
    },
    submitCIL: ownProps.submitCIL
  };
}

// Connect function "wires" both of the map functions and returns a wrapper container for the component
export const CILNotificationCIL = connect(
  mapStateToProps,
  mapDispatchToProps
)(CILNotificationCILComponent);



// WEBPACK FOOTER //
// ./src/cil-notification/_components/cil/_components/cil.container.ts